class modalCopyInvoiceCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, $timeout) {
        $scope.modaldata = items1
        // 分页参数
        $scope.pageOpt2 = {
            totalItems: $scope.modaldata.totalItems, // 组件初始化设置总页数
            currentPage: $scope.modaldata.currentPage, // 设置显示第一页
            maxSize: $scope.modaldata.maxSize, // 每一叶显示记录数
        }
        httpRequest.get_dictByTypeArr(['invoice_status', 'ovat_tax_rate']).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.selectedHandle = function selectedHandle() {
            $scope.modaldata.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.modaldata.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            $scope.searchInvoicelist()
        }

        // 增加排序功能
        $scope.orderMap = {
            sortKey: 'createTime',
            sortVal: 'desc',
        }

        // 初始化参数
        $scope.modaldata.param = {
            cancelDateMax: '',
            cancelDateMin: '',
            custCodeName: '',
            diskCode: '',
            invType: '0',
            invoiceCode: '',
            invoiceCodeNumber: '',
            invoiceDateMax: '',
            invoiceDateMin: '',
            invoiceNumber: '',
            isCancel: '0',
            isList: '',
            isPrint: '',
            isRed: '0',
            isReopen: '',
            openPeople: '',
            ukeyCode: '',
            redApplicantType: $scope.modaldata.redApplicantType,
            invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
            invoiceDateEnd: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
            taxRate: '',
        }
        $scope.modaldata.param.orderMap = { createTime: 'desc' }
        $timeout(() => {
            // 日期设置
            $('#J_datetimeStart').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now
            }).on('changeDate', (e) => {
                const dateText = e.date
                $scope.modaldata.param.invoiceDateMin = e.target.value
                $('#J_datetimeEnd').datetimepicker('setStartDate', dateText)
            })
            $('#J_datetimeEnd').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now
            }).on('changeDate', (e) => {
                const dateText = e.date
                $scope.modaldata.param.invoiceDateMax = e.target.value
                $('#J_datetimeStart').datetimepicker('setEndDate', dateText)
            })
        })
        $scope.datetimeStartChange = function (e) {
            $scope.modaldata.param.invoiceDateMin = e.currentTarget.value
        }
        $scope.datetimeEndChange = function (e) {
            $scope.modaldata.param.invoiceDateMax = e.currentTarget.value
        }

        function queryInvoiceList(v) {
            httpRequest.post_getNormalBlueInvoice(v).then((res) => {
                $scope.modaldata.list = res.data.value.list
                // 会写分页参数
                $scope.pageOpt2.totalItems = res.data.value.total
                $scope.pageOpt2.currentPage = res.data.value.pageNum
                $scope.pageOpt2.maxSize = res.data.value.pageSize
            })
        }
        // 分页
        $scope.pageChanged2 = function () {
            const _req = {
                pageNum: $scope.pageOpt2.currentPage,
                pageSize: $scope.pageOpt2.maxSize,
                orderMap: $scope.modaldata.param.orderMap,
                param: $scope.modaldata.param,
            }
            queryInvoiceList(_req)
        }
        // 搜索
        $scope.searchInvoicelist = function () {
            const _req = {
                pageNum: 1,
                pageSize: 5,
                orderMap: $scope.modaldata.param.orderMap,
                param: $scope.modaldata.param,
            }
            queryInvoiceList(_req)
        }
        // 选择
        $scope.chooseInvoiceItem = function (item) {
            if($scope.modaldata.redApplicantType == '2'){ 
                httpRequest.get_getNormalBlueInvoiceDetial(item.invoiceId).then((res)=>{
                    $uibModalInstance.close(res.data.value)
                }) 
            }else{ 
                httpRequest.post_getOvatInvoice(item.invoiceId).then((res) => {
                    $uibModalInstance.close(res.data.value)
                })
            }
        }

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}

modalCopyInvoiceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', '$timeout']
export default modalCopyInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/modalRedFindInvCtrl.js